export const WHITELISTED_SYSTEM_KEYS = new Set([
  "NODE_ENV",
  "CI",
  "VERCEL_ENV",
]);

export function readSystemEnv(key: string): string | undefined {
  if (WHITELISTED_SYSTEM_KEYS.has(key)) {

    // [SUPPORT_SYSTEM_ENV] NODE.JS
    if (typeof process !== "undefined" && process.env) {
      return process.env[key];
    }
  }
  return undefined;
}
